// extracted by mini-css-extract-plugin
export var confirmationTitle = "_redotech-redo-return-app-src-order-return-flow-address-edit-modal-confirmation-title";
export var disclaimer = "_redotech-redo-return-app-src-order-return-flow-address-edit-modal-disclaimer";
export var error = "_redotech-redo-return-app-src-order-return-flow-address-edit-modal-error";